import React, { forwardRef, useImperativeHandle, useState } from "react";
import Table from "../../table/Table";
import Input from "../../inputs/Input";
import Dropdown from "../../inputs/Dropdown";
import moment from "moment";
import { DeleteIcon } from "../../../utils/utils";
import { useSelector } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import store from "../../../redux/store";
import { staffMasterAPI } from "../../../utils/apis";
import { get_staff_list } from "../../../screens/MasterData/masterdataSlice";
import { Alerts } from "../../Alerts/Alerts";
import { staffOptions } from "../../../utils/data";
import {
  setLoadingMain,
  setMessAlert,
  setOpenAlert,
} from "../../../redux/slice/actionSlice";

const defaultRow = (id) => ({
  id,
  empcode: "",
  empname: "",
  dob: "",
  designation: "",
  role: "",
  joining: "",
});

const AddStaffMaster = forwardRef(({ setOpen, open, obj = {} }, ref) => {
  const [staffList, setStaffList] = useState([]);
  const { user_id, emp_id } = useSelector((state) => state.other);

  const validate = () => {
    const errors = [];
    const codes = [];

    staffList.forEach((staff, idx) => {
      if (!staff.empcode?.trim())
        errors.push(`Row ${idx + 1}: Enter Employee Code`);
      else codes.push(staff.empcode.trim());

      if (!staff.empname?.trim())
        errors.push(`Row ${idx + 1}: Enter Employee Name`);
      if (!staff.dob) errors.push(`Row ${idx + 1}: Select Date of Birth`);
      if (!staff.designation?.trim())
        errors.push(`Row ${idx + 1}: Enter Designation`);
      if (!staff.role?.trim()) errors.push(`Row ${idx + 1}: Select Role`);
      if (!staff.joining) errors.push(`Row ${idx + 1}: Select Date of Joining`);
    });

    if (new Set(codes).size !== codes.length) {
      errors.push("Duplicate Employee Codes not allowed.");
    }

    if (staffList.length === 0) {
      errors.push("Please add at least one staff entry.");
    }

    return errors;
  };

  const handleSave = async () => {
    const errors = validate();
    if (errors.length > 0) {
      store.dispatch(setOpenAlert(true));
      store.dispatch(setMessAlert(errors));
      return;
    }

    try {
      store.dispatch(setLoadingMain(true));
      const body = new FormData();
      body.append("action", "create");
      body.append("agencyid", user_id);

      staffList.forEach((item) => {
        body.append("empcode[]", item.empcode.trim());
        body.append("empname[]", item.empname.trim());
        body.append("dob[]", moment(item.dob).format("YYYY-MM-DD"));
        body.append("designation[]", item.designation.trim());
        body.append("role[]", item.role);
        body.append("joining[]", moment(item.joining).format("YYYY-MM-DD"));
      });

      if (emp_id) body.append("emp_code", emp_id);

      const { data } = await axios.post(staffMasterAPI, body);
      store.dispatch(setLoadingMain(false));

      if (data.success) {
        setStaffList([]);
        setOpen(false);
        toast(data.message, { position: "top-center" });
        store.dispatch(get_staff_list(obj));
      } else {
        store.dispatch(setOpenAlert(true));
        store.dispatch(setMessAlert(data.message));
      }
    } catch (err) {
      console.error("Error saving staff data:", err);
    }
  };

  console.log("staffList", staffList);
  const handleAddRow = () => {
    console.log("staffList 2", staffList);

    const errors = validate();
    if (staffList.length == 0 || errors.length == 0) {
      console.log("staffList inside", staffList);

      setStaffList([...staffList, defaultRow(staffList.length + 1)]);
    } else {
      store.dispatch(setOpenAlert(true));
      store.dispatch(setMessAlert(errors));
    }
  };

  const updateStaffField = (index, field, value) => {
    setStaffList((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  useImperativeHandle(ref, () => ({
    handleSaveProduct: handleSave,
    handleAddProduct: handleAddRow,
  }));

  return (
    <div>
      {open && staffList.length > 0 && (
        <Table
          mt={30}
          headData={[
            "EMPLOYEE CODE",
            "EMPLOYEE NAME",
            "DATE OF JOINING",
            "DESIGNATION",
            "ROLE",
            "DATE OF BIRTH",
            "ACTIONS",
          ]}
          body={
            <>
              {staffList.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    <Input
                      placeholder="EMPLOYEE CODE"
                      value={item.empcode}
                      onChange={(e) => {
                        const val = e.target.value.toUpperCase();
                        if (val.length <= 6)
                          updateStaffField(index, "empcode", val);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      placeholder="EMPLOYEE NAME"
                      value={item.empname}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (
                          val.length <= 30 &&
                          (/^([a-zA-Z ]+\s*){0,30}$/.test(val) || val === "")
                        )
                          updateStaffField(index, "empname", val);
                      }}
                    />
                  </td>
                  <td>
                    <Input
                      type="date"
                      value={item.joining}
                      onChange={(e) =>
                        updateStaffField(index, "joining", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <Input
                      placeholder="EMPLOYEE DESIGNATION"
                      value={item.designation}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val.length <= 15)
                          updateStaffField(index, "designation", val);
                      }}
                    />
                  </td>
                  <td>
                    <Dropdown
                      value={item.role}
                      onChange={(e) =>
                        updateStaffField(index, "role", e.target.value)
                      }
                      options={
                        <>
                          <option hidden value="-1">
                            SELECT
                          </option>
                          {staffOptions.map(({ value, label }) => (
                            <option key={value} value={value}>
                              {label}
                            </option>
                          ))}
                        </>
                      }
                    />
                  </td>
                  <td>
                    <Input
                      type="date"
                      value={item.dob}
                      max={moment(item.joining || new Date())
                        .subtract(18, "years")
                        .format("YYYY-MM-DD")}
                      onChange={(e) =>
                        updateStaffField(index, "dob", e.target.value)
                      }
                    />
                  </td>
                  <td>
                    <DeleteIcon
                      onClick={() =>
                        setStaffList((prev) =>
                          prev.filter((val) => val.id !== item.id)
                        )
                      }
                    />
                  </td>
                </tr>
              ))}
            </>
          }
        />
      )}
    </div>
  );
});

export default AddStaffMaster;
